/**
 * ReferralPage — 「リフェラル」統合ページ。
 *
 * 旧 UrlGeneratorPage / ReferralChannelsPage を 2 タブで統合。
 *  - URL 発行 : SNS 広告 / QR / 紙媒体等のタグ付き URL を発行
 *  - チャネル管理 : refTag のプリセット辞書（命名揺れ防止）
 *
 * URL クエリ ?tab=channels で初期タブを切替可能。
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Screen } from '@/components/layout/Screen';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { ReferralChannelsView } from '@/pages/referral-channels/ReferralChannelsPage';
import { UrlGeneratorView } from '@/pages/url-generator/UrlGeneratorPage';

type TabKey = 'generate' | 'channels';

export function ReferralPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial: TabKey =
    searchParams.get('tab') === 'channels' ? 'channels' : 'generate';
  const [tab, setTab] = useState<TabKey>(initial);

  // タブ変更を URL クエリにも反映（リロードや共有 URL で復元できるように）
  useEffect(() => {
    const cur = searchParams.get('tab');
    const next = tab === 'channels' ? 'channels' : null;
    if ((cur ?? null) !== next) {
      const params = new URLSearchParams(searchParams);
      if (next) params.set('tab', next);
      else params.delete('tab');
      setSearchParams(params, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <Screen
      title="リフェラル"
      description="SNS 広告 / QR / 紙媒体等の外部チャネルからの流入を計測するための URL 発行とチャネル管理。"
    >
      <Tabs value={tab} onValueChange={(v) => setTab(v as TabKey)}>
        <TabsList>
          <TabsTrigger value="generate">URL 発行</TabsTrigger>
          <TabsTrigger value="channels">チャネル管理</TabsTrigger>
        </TabsList>
        <TabsContent value="generate">
          <UrlGeneratorView />
        </TabsContent>
        <TabsContent value="channels">
          <ReferralChannelsView />
        </TabsContent>
      </Tabs>
    </Screen>
  );
}
